import AlertBanner from '../banner/AlertBanner'
import EventsManager from './EventsManager'
import Filters from '../abstracts/Filters'
import ModalBanner from '../banner/ModalBanner'

export const Etat = {
  wait: 'wait',
  enabled: 'allowed',
  denied: 'denied'
}
export default class BannerManager {
  constructor(parameters, ServiceManager, CookieManager, LanguageManager) {
    this.ServiceManager = ServiceManager
    this.CookieManager = CookieManager
    this.LanguageManager = LanguageManager
    this.parameters = parameters
    this.alerts = [new AlertBanner(parameters, LanguageManager)]
    this.panel = new ModalBanner(parameters, LanguageManager)
  }

  /**
   * Initialize HTML
   */
  init() {
    const body = document.body
    const div = document.createElement('div')
    let html = ''

    // init events
    this.events()

    // Construction des Panel + Alerts
    div.id = 'rousquilleRoot'
    body.appendChild(div, body)
    html = this.panel.content
    for (const alert of this.alerts) {
      html += alert.content
    }
    div.innerHTML = html

    EventsManager.dispatchEvent('rsq.manager.banner.build')

    // add Services
    let hasWaitingService = false
    for (const service of this.ServiceManager.services) {
      this.addService(service)

      if (Etat.wait === service.getStatus()) {
        hasWaitingService = true
      }
    }

    if (hasWaitingService) {
      this.setRootWaited()
    }

    // hide Alert in privacy page
    if (window.location.pathname == this.parameters.privacyUrl || window.location.href == this.parameters.privacyUrl) {
      div.classList.add('privacy')
    }

    EventsManager.dispatchEvent('rsq.manager.banner.services.added', this.ServiceManager.services)

    if (document.location.hash === this.parameters.hashtag && this.parameters.hashtag !== '') {
      this.openPanel()
    }
  }

  getStatusLiFromCookieStatus(cookieStatus) {
    switch (cookieStatus) {
      default:
      case 'wait':
        return Etat.wait
      case 'true':
        return Etat.enabled
      case 'false':
        return Etat.denied
    }
  }

  /**
   * Add HTML of a service
   * @param {service} service
   */
  addService(service) {
    // build service element markup
    let html = ''
    html += '  <div class="label">'
    html += `    <strong class="service-name" role="heading" aria-level="3">${service.name}</strong>`
    html += `    <span id="rsqCL${service.key}" class="listCookies"></span>`

    if (service.uri) {
      html += `    <span class="seeMore"><a href="${service.uri}" target="_blank">En savoir plus sur le site officiel</a></span>`
    }

    html += '  </div>'
    html += '  <div class="actions">'
    html += `    <button class="btn allow">${this.LanguageManager.translations.allow}</button>`
    html += `    <button class="btn deny">${this.LanguageManager.translations.deny}</button>`
    html += '  </div>'

    let serviceItemEl = document.createElement('li')
    serviceItemEl.classList.add('service', `service-${service.key}`, `group-${service.group.key}`, this.getStatusLiFromCookieStatus(service.getStatus()))
    serviceItemEl.setAttribute('data-key', service.key)
    serviceItemEl.innerHTML = html

    // allow external components to filter banner element before display
    serviceItemEl = Filters.applyFilters('banners.services.service.domElement', serviceItemEl, service)

    const groupEl = document.querySelector(`#group-${service.group.key}`)
    if (groupEl) {
      groupEl.classList.remove('rousquilleHidden')

      const groupServicesEl = groupEl.querySelector('.services')
      if (groupServicesEl) {
        groupServicesEl.append(serviceItemEl)
      }
    }

    // set root html
    if (service.getStatus() != Etat.wait) {
      this.setRootAnswered()
    }

    // Affichage de la liste des cookies sous le service
    this.displayCookiesList(service)

    //
    service.added = true
  }

  /**
   * On ouvre l'alerte
   */
  openAlert() {
    EventsManager.dispatchEvent('rsq.manager.banner.alert.open')
  }

  /**
   * On ferme l'alerte
   */
  closeAlert() {
    EventsManager.dispatchEvent('rsq.manager.banner.alert.close')
  }

  /**
   * On ouvre le panel
   */
  openPanel() {
    this.panel.open()
  }

  /**
   * On ferme le panel utilisé
   */
  closePanel() {
    this.panel.close()
  }

  /**
   * Click on html service btn
   */
  clickServiceBtn(element) {
    const serviceRow = element.closest('li.service')
    const serviceKey = serviceRow.dataset.key
    const service = this.ServiceManager.getService(serviceKey)
    const status = element.classList.contains('allow') ? Etat.enabled : Etat.denied

    // on active/desactive le service
    if (status === Etat.enabled) {
      service.enable()
    } else {
      service.deny()
    }

    // Affichage de la liste des cookies sous le service
    this.displayCookiesList(service)

    // affichage
    serviceRow.classList.remove(Etat.enabled, Etat.denied, Etat.wait)
    serviceRow.classList.add(status)

    // set html root
    this.setRootAnswered()
  }

  displayCookiesList(service) {
    let html = ''
    const nb = service.cookies.length
    const _public = this

    if (document.getElementById(`rsqCL${service.key}`) !== null) {
      document.getElementById(`rsqCL${service.key}`).innerHTML = '...'
    }

    setTimeout(() => {
      // tarteaucitron.cookie.checkCount(key);
      if (service.isDenied() && nb > 0) {
        html += `${_public.LanguageManager.translations.useCookie} ${nb} cookie${nb > 1 ? 's' : ''}.`
      }

      // @todo : calculer le vrai nb de cookies
      if (service.isEnabled() && nb > 0) {
        // html += _public.LanguageManager.translations.useCookieCurrent + ' ' + nb + ' cookie' + (nb>1?'s':'') + '.';
        html += `${_public.LanguageManager.translations.useCookie} ${nb} cookie${nb > 1 ? 's' : ''}.`
      }

      if (nb == 0) {
        html += service.isEnabled() ? _public.LanguageManager.translations.useNoCookie : _public.LanguageManager.translations.noCookie
      }

      if (document.getElementById(`rsqCL${service.key}`) !== null) {
        document.getElementById(`rsqCL${service.key}`).innerHTML = html
      }
    }, 500)
  }

  getRootElement() {
    return document.getElementById('rousquilleRoot')
  }

  getServicesElement() {
    return document.getElementById('rousquilleServices')
  }

  setRootAnswered() {
    // si tous les services sont answered
    if (this.CookieManager.getDynEtat() !== Etat.wait) {
      const rootEl = this.getRootElement()
      rootEl.classList.remove('wait')
      rootEl.classList.add('answered')
    }
  }

  setRootWaited() {
    const rootEl = this.getRootElement()
    rootEl.classList.remove('answered')
    rootEl.classList.add('wait')
  }

  /**
   * @deprecated
   * @param type
   */
  jsSizing(type) {
    let closeButtonHeight
    let servicesMarginTop
    let mainHeight
    let servicesHeight
    switch (type) {
      case 'panel':
        // Logger.log('JS SIZING :: PANEL')
        // height of the services list container
        const rootEl = this.getRootElement()
        const servicesEl = this.getServicesElement()
        if (rootEl && servicesEl) {
          // reset
          servicesEl.style.height = 'auto'

          // calculate
          mainHeight = document.getElementById('rousquille').offsetHeight
          servicesMarginTop = getComputedStyle(servicesEl).marginTop.slice(0, -2)
          closeButtonHeight = document.getElementById('rousquilleClosePanel').offsetHeight

          // apply
          // servicesHeight = mainHeight - closeButtonHeight + 2
          servicesHeight = mainHeight - servicesMarginTop
          servicesEl.style.height = `${servicesHeight}px`
          servicesEl.style.overflowX = 'auto'
        }
        break
    }
  }

  events() {
    const thisBm = this
    document.addEventListener('rsq.manager.banner.build', () => {
      // Set all Cookies status
      for (const element of document.querySelectorAll('#rousquilleRoot .btnAll')) {
        const status = element.classList.contains('allowAll') ? 'allow' : 'deny'
        element.addEventListener('click', (e) => {
          // on simule le click sur tous les services
          for (const btn of document.querySelectorAll(`.services .actions .btn.${status}`)) {
            btn.click()
          }

          EventsManager.dispatchEvent(`rsq.banner.clickButton.${status}All`)

          // close
          thisBm.closePanel()
        })
      }

      document.querySelector('.link-privacy').addEventListener('click', (e) => {
        e.preventDefault()

        document.location = thisBm.parameters.privacyUrl
      })

      // Open Panel
      for (const element of document.querySelectorAll('.action.openPanel')) {
        element.addEventListener('click', () => {
          EventsManager.dispatchEvent('rsq.banner.clickButton.openPanel')

          thisBm.openPanel()
        })
      }

      // Click link href = hashtag
      for (const element of document.querySelectorAll(`[href="${this.parameters.hashtag}"]`)) {
        element.addEventListener('click', (e) => {
          thisBm.openPanel()
        })
      }

      // Rousquille status on panel
      this.getRootElement().classList.add(this.CookieManager.status)
    }, false)


    document.addEventListener('rsq.manager.banner.services.added', (e) => {
      // Individual Btn
      for (const btnEl of document.querySelectorAll('.service .actions .btn')) {
        btnEl.addEventListener('click', () => thisBm.clickServiceBtn(btnEl))
      }
    }, false)
  }
}
